import { Navigate, useLocation } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequireAdmin from '../settings/RequireAdmin';

// Index redirect that preserves the query string, so deep-links such as
// /admin/activities?tab=error&search=<batchId> still reach Errors with their filter.
function IndexRedirect() {
    const { search } = useLocation();
    return <Navigate to={`error${search}`} replace />;
}

function UserActivityRedirect() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    params.set('tab', 'users');
    return <Navigate to={`/admin/settings/sector7?${params}`} replace />;
}

const ActivitiesApp = lazyRetry(() => import('./ActivitiesApp'));
const ErrorLog = lazyRetry(() => import('./components/ErrorLog'));
const AuditLog = lazyRetry(() => import('./components/AuditLog'));
const BatchHistoryLog = lazyRetry(() => import('./components/BatchHistoryLog'));
const RetentionSweeps = lazyRetry(() => import('./components/RetentionSweeps'));
const ImportAuditLog = lazyRetry(() => import('./components/ImportAuditLog'));
const ApprovalHistoryLog = lazyRetry(() => import('./components/ApprovalHistoryLog'));

const ActivitiesAppRoute: FuseRouteItemType = {
    path: 'admin/activities',
    element: <ActivitiesApp />,
    children: [
        { path: 'users', element: <UserActivityRedirect /> },
        {
            path: 'error',
            element: <ErrorLog />
        },
        {
            path: 'audit',
            element: (
                <RequireAdmin>
                    <AuditLog />
                </RequireAdmin>
            )
        },
        {
            path: 'imports',
            element: (
                <RequireAdmin>
                    <ImportAuditLog />
                </RequireAdmin>
            )
        },
        {
            path: 'history',
            element: <BatchHistoryLog />
        },
        {
            // Custom Code Errors is no longer its own page — it lives inside the
            // unified Errors console as Source: Custom Code. Keep the old URL working.
            path: 'customcode',
            element: <Navigate to="/admin/activities/error?source=Custom%20Code" replace />
        },
        {
            path: 'retention',
            element: (
                <RequireAdmin>
                    <RetentionSweeps />
                </RequireAdmin>
            )
        },
        {
            path: 'approvals',
            element: <ApprovalHistoryLog />
        },
        {
            path: '',
            element: <IndexRedirect />
        }
    ]
};

export default ActivitiesAppRoute;
